export default __webpack_public_path__ + "static/media/figma.ec5a66d1.svg";